import type { UserRole } from '@/types/database'

/** Painel de cada perfil (destino pós-login e da página inicial quando logado). */
export const roleDashboard: Record<UserRole, string> = {
  student: '/aluno/dashboard',
  instructor: '/instrutor/dashboard',
  admin: '/admin',
}
